export const TopicCreation = "TOPIC_CREATION";
export const TopicUpdate = "UPDATE_TOPIC";
export const Registration = "REGISTRATION";
export const SignIn = "SIGNIN";
export const Enroll = "ENROLL";
export const Leave = "LEAVE";
export const Submit = "TOPIC_SUBMIT";
export const TopicDelete = "DELETE_TOPIC";
export const WinnersPublish = "PUBLISH_WINNERS";
export const JurySavePoints = "JURY_SAVE_POINTS";
export const AddEditUserRole = "ADD_EDIT_USER_ROLE";
export const AddEditRole = "ADD_EDIT_ROLE";
export const AddEditEvent = "ADD_EDIT_Event";
